// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  CoachCalendarCoachFragmentDoc,
  CoachCalendarCoachingSessionFragmentDoc,
} from '../ScheduleModal/__generated-gql-types__/CoachCalendar.generated';
import {
  ScheduleMessageModalCoachFragmentDoc,
  ScheduleMessageModalCoachingSessionFragmentDoc,
} from '../ScheduleModal/__generated-gql-types__/ScheduleMessageModal.generated';
import {
  PackageSelectionCoachFragmentDoc,
  PackageSelectionOfferingPackageFragmentDoc,
} from '../ScheduleModal/__generated-gql-types__/PackageSelection.generated';
import { CategorySelectionCoachFragmentDoc } from '../ScheduleModal/__generated-gql-types__/CategorySelection.generated';
import { AddAdditionalTimeCoachingSessionFragmentDoc } from '../ScheduleModal/__generated-gql-types__/AddAdditionalTime.generated';
import { BaseScheduleModalLayoutOrderFragmentDoc } from '../ScheduleModal/__generated-gql-types__/BaseScheduleModalLayout.generated';
import { AssignExistingOrderOrderFragmentDoc } from '../ScheduleModal/__generated-gql-types__/AssignExistingOrder.generated';
import { AssignCoachingCardOrderFragmentDoc } from '../../../subscriber/__generated-gql-types__/AssignCoachingCard.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduleModalCoachFragment = {
  __typename?: 'Coach';
  id: string;
  newExperience?: boolean | null;
  tier: Types.SkuTier;
  slug: string;
  averageReviewRate: number;
  reviewTotal: number;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  hourlyRate?: number | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    category: { __typename?: 'Category'; id: string; name: string };
  }> | null;
};

export type ScheduleModalCoachingSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  durationInMinute: number;
  startAt: number;
  endAt: number;
  content:
    | { __typename: 'Class'; id: string; name?: string | null }
    | {
        __typename: 'OneOnOneSession';
        title: string;
        introOrder?: {
          __typename?: 'Order';
          introCall?: {
            __typename?: 'IntroCall';
            packages?: Array<{
              __typename?: 'OfferingPackage';
              id: string;
            }> | null;
          } | null;
        } | null;
      };
  coach: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  };
};

export type ScheduleModalOrderFragment = {
  __typename?: 'Order';
  id: string;
  finalAmount?: number | null;
  submittedAt?: number | null;
  createdAt: number;
  hourlyOrder?: {
    __typename?: 'HourlyOrder';
    timeInMinute: number;
    sku?: { __typename?: 'Sku'; id: string; tier: Types.SkuTier } | null;
  } | null;
  subscriptionOrder?: {
    __typename?: 'SubscriptionOrder';
    phaseType?: Types.SkuPhaseType | null;
    timeInMinute: number;
    sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    customerSubscription: {
      __typename?: 'CustomerSubscription';
      id: string;
      nextCreditGrantAt?: number | null;
      sku: {
        __typename?: 'Sku';
        id: string;
        tier: Types.SkuTier;
        family: Types.SkuFamily;
      };
    };
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    tier: Types.SkuTier;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    };
  };
  packageOrder?: {
    __typename?: 'OfferingPackage';
    id: string;
    name: string;
    slug?: string | null;
    imageLink?: string | null;
    prices?: Array<{
      __typename?: 'OfferingPackagePrice';
      sku?: string | null;
      tier?: Types.SkuTier | null;
      packageCoachingTime?: {
        __typename?: 'PackageCoachingTime';
        exactTimeInMinute?: number | null;
        estimate?: {
          __typename?: 'IntRange';
          start?: number | null;
          end?: number | null;
        } | null;
      } | null;
    }> | null;
    category?: { __typename?: 'Category'; id: string; slug: string } | null;
  } | null;
};

export type ScheduleModalOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  name: string;
  slug?: string | null;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    tier?: Types.SkuTier | null;
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
  category?: { __typename?: 'Category'; id: string; slug: string } | null;
};

export type ScheduleModalUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ScheduleModalUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      id: string;
      newExperience?: boolean | null;
      lelandMembership?: {
        __typename?: 'LelandMembership';
        tier?: Types.SkuTier | null;
        active: boolean;
        cycles?: Array<{
          __typename?: 'LelandMembershipCycle';
          timeAvailable: number;
          start: number;
          end: number;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ScheduleModalCreateOrderMutationVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  hourlyOrder: Types.HourlyOrderInput;
  tier?: Types.InputMaybe<Types.SkuTier>;
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
}>;

export type ScheduleModalCreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: {
    __typename?: 'Order';
    id: string;
    finalAmount?: number | null;
    submittedAt?: number | null;
    createdAt: number;
    hourlyOrder?: {
      __typename?: 'HourlyOrder';
      timeInMinute: number;
      sku?: { __typename?: 'Sku'; id: string; tier: Types.SkuTier } | null;
    } | null;
    subscriptionOrder?: {
      __typename?: 'SubscriptionOrder';
      phaseType?: Types.SkuPhaseType | null;
      timeInMinute: number;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      customerSubscription: {
        __typename?: 'CustomerSubscription';
        id: string;
        nextCreditGrantAt?: number | null;
        sku: {
          __typename?: 'Sku';
          id: string;
          tier: Types.SkuTier;
          family: Types.SkuFamily;
        };
      };
    } | null;
    coach: {
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      };
    };
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      slug?: string | null;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        tier?: Types.SkuTier | null;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
    } | null;
  };
};

export type ScheduleModalGetOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['OrderUrn']['input'];
}>;

export type ScheduleModalGetOrderQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    finalAmount?: number | null;
    submittedAt?: number | null;
    createdAt: number;
    hourlyOrder?: {
      __typename?: 'HourlyOrder';
      timeInMinute: number;
      sku?: { __typename?: 'Sku'; id: string; tier: Types.SkuTier } | null;
    } | null;
    subscriptionOrder?: {
      __typename?: 'SubscriptionOrder';
      phaseType?: Types.SkuPhaseType | null;
      timeInMinute: number;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      customerSubscription: {
        __typename?: 'CustomerSubscription';
        id: string;
        nextCreditGrantAt?: number | null;
        sku: {
          __typename?: 'Sku';
          id: string;
          tier: Types.SkuTier;
          family: Types.SkuFamily;
        };
      };
    } | null;
    coach: {
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      };
    };
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      slug?: string | null;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        tier?: Types.SkuTier | null;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
    } | null;
  } | null;
};

export type ScheduleModalMatchSkusByTimeQueryVariables = Types.Exact<{
  tier: Types.SkuTier;
}>;

export type ScheduleModalMatchSkusByTimeQuery = {
  __typename?: 'Query';
  matchSkusByTime: Array<{
    __typename?: 'Sku';
    id: string;
    name: string;
    price: number;
  }>;
};

export type ScheduleModalEnoughTimeToScheduleQueryVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  startAt: Types.Scalars['Long']['input'];
  endAt: Types.Scalars['Long']['input'];
}>;

export type ScheduleModalEnoughTimeToScheduleQuery = {
  __typename?: 'Query';
  enoughTimeToSchedule: boolean;
};

export type ScheduleModalGetUnassignedOrdersQueryVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
}>;

export type ScheduleModalGetUnassignedOrdersQuery = {
  __typename?: 'Query';
  unassignedOrders: Array<{
    __typename?: 'Order';
    submittedAt?: number | null;
    id: string;
    createdAt: number;
    category?: { __typename?: 'Category'; id: string } | null;
    subscriptionOrder?: {
      __typename?: 'SubscriptionOrder';
      phaseType?: Types.SkuPhaseType | null;
      timeInMinute: number;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      customerSubscription: {
        __typename?: 'CustomerSubscription';
        id: string;
        nextCreditGrantAt?: number | null;
        sku: {
          __typename?: 'Sku';
          id: string;
          tier: Types.SkuTier;
          family: Types.SkuFamily;
        };
      };
    } | null;
    coach: {
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      };
    };
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      slug?: string | null;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        tier?: Types.SkuTier | null;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
    } | null;
    hourlyOrder?: {
      __typename?: 'HourlyOrder';
      timeInMinute: number;
      sku?: { __typename?: 'Sku'; id: string; tier: Types.SkuTier } | null;
    } | null;
  }>;
};

export const ScheduleModalCoachFragmentDoc = gql`
  fragment ScheduleModal_Coach on Coach {
    id
    coachingRelationship {
      id
    }
    newExperience
    tier
    coachingTimeSummary {
      availableTime
      hasUnlimitedPackage
      cycles {
        timeInMinute
        start
        end
      }
    }
    slug
    ...CoachCalendar_Coach
    ...ScheduleMessageModal_Coach
    ...PackageSelection_Coach
    ...CategorySelection_Coach
  }
  ${CoachCalendarCoachFragmentDoc}
  ${ScheduleMessageModalCoachFragmentDoc}
  ${PackageSelectionCoachFragmentDoc}
  ${CategorySelectionCoachFragmentDoc}
`;
export const ScheduleModalCoachingSessionFragmentDoc = gql`
  fragment ScheduleModal_CoachingSession on CoachingSession {
    id
    content {
      ... on OneOnOneSession {
        introOrder {
          introCall {
            packages {
              id
            }
          }
        }
      }
    }
    durationInMinute
    ...CoachCalendar_CoachingSession
    ...ScheduleMessageModal_CoachingSession
    ...AddAdditionalTime_CoachingSession
  }
  ${CoachCalendarCoachingSessionFragmentDoc}
  ${ScheduleMessageModalCoachingSessionFragmentDoc}
  ${AddAdditionalTimeCoachingSessionFragmentDoc}
`;
export const ScheduleModalOrderFragmentDoc = gql`
  fragment ScheduleModal_Order on Order {
    id
    ...BaseScheduleModalLayout_Order
    ...AssignExistingOrder_Order
  }
  ${BaseScheduleModalLayoutOrderFragmentDoc}
  ${AssignExistingOrderOrderFragmentDoc}
`;
export const ScheduleModalOfferingPackageFragmentDoc = gql`
  fragment ScheduleModal_OfferingPackage on OfferingPackage {
    id
    ...PackageSelection_OfferingPackage
  }
  ${PackageSelectionOfferingPackageFragmentDoc}
`;
export const ScheduleModalUserDocument = gql`
  query ScheduleModal_User {
    user {
      id
      applicant {
        id
        newExperience
        lelandMembership {
          tier
          active
          cycles {
            timeAvailable
            start
            end
          }
        }
      }
    }
  }
`;

/**
 * __useScheduleModalUserQuery__
 *
 * To run a query within a React component, call `useScheduleModalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleModalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleModalUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduleModalUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ScheduleModalUserQuery,
    ScheduleModalUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduleModalUserQuery,
    ScheduleModalUserQueryVariables
  >(ScheduleModalUserDocument, options);
}
export function useScheduleModalUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduleModalUserQuery,
    ScheduleModalUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduleModalUserQuery,
    ScheduleModalUserQueryVariables
  >(ScheduleModalUserDocument, options);
}
export function useScheduleModalUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduleModalUserQuery,
    ScheduleModalUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduleModalUserQuery,
    ScheduleModalUserQueryVariables
  >(ScheduleModalUserDocument, options);
}
export type ScheduleModalUserQueryHookResult = ReturnType<
  typeof useScheduleModalUserQuery
>;
export type ScheduleModalUserLazyQueryHookResult = ReturnType<
  typeof useScheduleModalUserLazyQuery
>;
export type ScheduleModalUserSuspenseQueryHookResult = ReturnType<
  typeof useScheduleModalUserSuspenseQuery
>;
export type ScheduleModalUserQueryResult = Apollo.QueryResult<
  ScheduleModalUserQuery,
  ScheduleModalUserQueryVariables
>;
export const ScheduleModalCreateOrderDocument = gql`
  mutation ScheduleModal_CreateOrder(
    $coachUrn: CoachUrn!
    $hourlyOrder: HourlyOrderInput!
    $tier: SkuTier
    $categoryUrn: CategoryUrn
  ) {
    createOrder(
      coachUrn: $coachUrn
      hourlyOrder: $hourlyOrder
      tier: $tier
      categoryUrn: $categoryUrn
    ) {
      ...ScheduleModal_Order
    }
  }
  ${ScheduleModalOrderFragmentDoc}
`;
export type ScheduleModalCreateOrderMutationFn = Apollo.MutationFunction<
  ScheduleModalCreateOrderMutation,
  ScheduleModalCreateOrderMutationVariables
>;

/**
 * __useScheduleModalCreateOrderMutation__
 *
 * To run a mutation, you first call `useScheduleModalCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleModalCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleModalCreateOrderMutation, { data, loading, error }] = useScheduleModalCreateOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      hourlyOrder: // value for 'hourlyOrder'
 *      tier: // value for 'tier'
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useScheduleModalCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ScheduleModalCreateOrderMutation,
    ScheduleModalCreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ScheduleModalCreateOrderMutation,
    ScheduleModalCreateOrderMutationVariables
  >(ScheduleModalCreateOrderDocument, options);
}
export type ScheduleModalCreateOrderMutationHookResult = ReturnType<
  typeof useScheduleModalCreateOrderMutation
>;
export type ScheduleModalCreateOrderMutationResult =
  Apollo.MutationResult<ScheduleModalCreateOrderMutation>;
export type ScheduleModalCreateOrderMutationOptions =
  Apollo.BaseMutationOptions<
    ScheduleModalCreateOrderMutation,
    ScheduleModalCreateOrderMutationVariables
  >;
export const ScheduleModalGetOrderDocument = gql`
  query ScheduleModal_GetOrder($orderId: OrderUrn!) {
    order(id: $orderId) {
      ...ScheduleModal_Order
    }
  }
  ${ScheduleModalOrderFragmentDoc}
`;

/**
 * __useScheduleModalGetOrderQuery__
 *
 * To run a query within a React component, call `useScheduleModalGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleModalGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleModalGetOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useScheduleModalGetOrderQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduleModalGetOrderQuery,
    ScheduleModalGetOrderQueryVariables
  > &
    (
      | { variables: ScheduleModalGetOrderQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduleModalGetOrderQuery,
    ScheduleModalGetOrderQueryVariables
  >(ScheduleModalGetOrderDocument, options);
}
export function useScheduleModalGetOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduleModalGetOrderQuery,
    ScheduleModalGetOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduleModalGetOrderQuery,
    ScheduleModalGetOrderQueryVariables
  >(ScheduleModalGetOrderDocument, options);
}
export function useScheduleModalGetOrderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduleModalGetOrderQuery,
    ScheduleModalGetOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduleModalGetOrderQuery,
    ScheduleModalGetOrderQueryVariables
  >(ScheduleModalGetOrderDocument, options);
}
export type ScheduleModalGetOrderQueryHookResult = ReturnType<
  typeof useScheduleModalGetOrderQuery
>;
export type ScheduleModalGetOrderLazyQueryHookResult = ReturnType<
  typeof useScheduleModalGetOrderLazyQuery
>;
export type ScheduleModalGetOrderSuspenseQueryHookResult = ReturnType<
  typeof useScheduleModalGetOrderSuspenseQuery
>;
export type ScheduleModalGetOrderQueryResult = Apollo.QueryResult<
  ScheduleModalGetOrderQuery,
  ScheduleModalGetOrderQueryVariables
>;
export const ScheduleModalMatchSkusByTimeDocument = gql`
  query ScheduleModal_MatchSkusByTime($tier: SkuTier!) {
    matchSkusByTime(tier: $tier, timeInMinute: 60, period: ONE_TIME) {
      id
      name
      price
    }
  }
`;

/**
 * __useScheduleModalMatchSkusByTimeQuery__
 *
 * To run a query within a React component, call `useScheduleModalMatchSkusByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleModalMatchSkusByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleModalMatchSkusByTimeQuery({
 *   variables: {
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useScheduleModalMatchSkusByTimeQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduleModalMatchSkusByTimeQuery,
    ScheduleModalMatchSkusByTimeQueryVariables
  > &
    (
      | {
          variables: ScheduleModalMatchSkusByTimeQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduleModalMatchSkusByTimeQuery,
    ScheduleModalMatchSkusByTimeQueryVariables
  >(ScheduleModalMatchSkusByTimeDocument, options);
}
export function useScheduleModalMatchSkusByTimeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduleModalMatchSkusByTimeQuery,
    ScheduleModalMatchSkusByTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduleModalMatchSkusByTimeQuery,
    ScheduleModalMatchSkusByTimeQueryVariables
  >(ScheduleModalMatchSkusByTimeDocument, options);
}
export function useScheduleModalMatchSkusByTimeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduleModalMatchSkusByTimeQuery,
    ScheduleModalMatchSkusByTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduleModalMatchSkusByTimeQuery,
    ScheduleModalMatchSkusByTimeQueryVariables
  >(ScheduleModalMatchSkusByTimeDocument, options);
}
export type ScheduleModalMatchSkusByTimeQueryHookResult = ReturnType<
  typeof useScheduleModalMatchSkusByTimeQuery
>;
export type ScheduleModalMatchSkusByTimeLazyQueryHookResult = ReturnType<
  typeof useScheduleModalMatchSkusByTimeLazyQuery
>;
export type ScheduleModalMatchSkusByTimeSuspenseQueryHookResult = ReturnType<
  typeof useScheduleModalMatchSkusByTimeSuspenseQuery
>;
export type ScheduleModalMatchSkusByTimeQueryResult = Apollo.QueryResult<
  ScheduleModalMatchSkusByTimeQuery,
  ScheduleModalMatchSkusByTimeQueryVariables
>;
export const ScheduleModalEnoughTimeToScheduleDocument = gql`
  query ScheduleModal_EnoughTimeToSchedule(
    $coachUrn: CoachUrn!
    $startAt: Long!
    $endAt: Long!
  ) {
    enoughTimeToSchedule(coachUrn: $coachUrn, startAt: $startAt, endAt: $endAt)
  }
`;

/**
 * __useScheduleModalEnoughTimeToScheduleQuery__
 *
 * To run a query within a React component, call `useScheduleModalEnoughTimeToScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleModalEnoughTimeToScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleModalEnoughTimeToScheduleQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useScheduleModalEnoughTimeToScheduleQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduleModalEnoughTimeToScheduleQuery,
    ScheduleModalEnoughTimeToScheduleQueryVariables
  > &
    (
      | {
          variables: ScheduleModalEnoughTimeToScheduleQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduleModalEnoughTimeToScheduleQuery,
    ScheduleModalEnoughTimeToScheduleQueryVariables
  >(ScheduleModalEnoughTimeToScheduleDocument, options);
}
export function useScheduleModalEnoughTimeToScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduleModalEnoughTimeToScheduleQuery,
    ScheduleModalEnoughTimeToScheduleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduleModalEnoughTimeToScheduleQuery,
    ScheduleModalEnoughTimeToScheduleQueryVariables
  >(ScheduleModalEnoughTimeToScheduleDocument, options);
}
export function useScheduleModalEnoughTimeToScheduleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduleModalEnoughTimeToScheduleQuery,
    ScheduleModalEnoughTimeToScheduleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduleModalEnoughTimeToScheduleQuery,
    ScheduleModalEnoughTimeToScheduleQueryVariables
  >(ScheduleModalEnoughTimeToScheduleDocument, options);
}
export type ScheduleModalEnoughTimeToScheduleQueryHookResult = ReturnType<
  typeof useScheduleModalEnoughTimeToScheduleQuery
>;
export type ScheduleModalEnoughTimeToScheduleLazyQueryHookResult = ReturnType<
  typeof useScheduleModalEnoughTimeToScheduleLazyQuery
>;
export type ScheduleModalEnoughTimeToScheduleSuspenseQueryHookResult =
  ReturnType<typeof useScheduleModalEnoughTimeToScheduleSuspenseQuery>;
export type ScheduleModalEnoughTimeToScheduleQueryResult = Apollo.QueryResult<
  ScheduleModalEnoughTimeToScheduleQuery,
  ScheduleModalEnoughTimeToScheduleQueryVariables
>;
export const ScheduleModalGetUnassignedOrdersDocument = gql`
  query ScheduleModal_GetUnassignedOrders($coachUrn: CoachUrn!) {
    unassignedOrders(coachUrn: $coachUrn) {
      ...AssignCoachingCard_Order
      category {
        id
      }
    }
  }
  ${AssignCoachingCardOrderFragmentDoc}
`;

/**
 * __useScheduleModalGetUnassignedOrdersQuery__
 *
 * To run a query within a React component, call `useScheduleModalGetUnassignedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleModalGetUnassignedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleModalGetUnassignedOrdersQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *   },
 * });
 */
export function useScheduleModalGetUnassignedOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduleModalGetUnassignedOrdersQuery,
    ScheduleModalGetUnassignedOrdersQueryVariables
  > &
    (
      | {
          variables: ScheduleModalGetUnassignedOrdersQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduleModalGetUnassignedOrdersQuery,
    ScheduleModalGetUnassignedOrdersQueryVariables
  >(ScheduleModalGetUnassignedOrdersDocument, options);
}
export function useScheduleModalGetUnassignedOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduleModalGetUnassignedOrdersQuery,
    ScheduleModalGetUnassignedOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduleModalGetUnassignedOrdersQuery,
    ScheduleModalGetUnassignedOrdersQueryVariables
  >(ScheduleModalGetUnassignedOrdersDocument, options);
}
export function useScheduleModalGetUnassignedOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduleModalGetUnassignedOrdersQuery,
    ScheduleModalGetUnassignedOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduleModalGetUnassignedOrdersQuery,
    ScheduleModalGetUnassignedOrdersQueryVariables
  >(ScheduleModalGetUnassignedOrdersDocument, options);
}
export type ScheduleModalGetUnassignedOrdersQueryHookResult = ReturnType<
  typeof useScheduleModalGetUnassignedOrdersQuery
>;
export type ScheduleModalGetUnassignedOrdersLazyQueryHookResult = ReturnType<
  typeof useScheduleModalGetUnassignedOrdersLazyQuery
>;
export type ScheduleModalGetUnassignedOrdersSuspenseQueryHookResult =
  ReturnType<typeof useScheduleModalGetUnassignedOrdersSuspenseQuery>;
export type ScheduleModalGetUnassignedOrdersQueryResult = Apollo.QueryResult<
  ScheduleModalGetUnassignedOrdersQuery,
  ScheduleModalGetUnassignedOrdersQueryVariables
>;
